module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "fixed": "",
      "back": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("选择城市")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "present"
  }, [_c('span', {
    staticClass: "present-item"
  }, [_vm._v("当前城市")]), _vm._v(" "), _c('span', {
    staticClass: "city-name"
  }, [_vm._v(_vm._s(_vm.cityName))])]), _vm._v(" "), _c('div', {
    staticClass: "city"
  }, [_c('p', {
    staticClass: "city-title"
  }, [_vm._v("热门城市")]), _vm._v(" "), _c('ul', {
    staticClass: "city-group"
  }, _vm._l((_vm.cityList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "city-item",
      on: {
        "click": function($event) {
          _vm.onSelect(index)
        }
      }
    }, [_vm._v(_vm._s(item.cityName))])
  }))]), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eab7096c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/borrow/city.vue
// module id = 378
// module chunks = 1